import { Component, EventEmitter, Input, Output } from '@angular/core';
import { format, parseISO } from 'date-fns';

@Component({
  selector: 'form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  standalone: false,
})
export class FormFieldComponent {
  @Input() label: string;
  @Input() type: string;
  @Input() value: any;
  @Input() Type: any;
  @Input() nclass: any;
  @Input() noflex: boolean;
  @Input() inputName: string;
  @Output() switchChanged: EventEmitter<any> = new EventEmitter<any>();

  goToLink(link: string) {
    window.open(link, '_blank');
  }

  formatDate(date: any) {
    if (date !== null && date !== undefined && date !== '') {
      return format(parseISO(date), 'MM-dd-yyyy');
    }
    return 'N/A';
  }

  onSwitchChange(event: any) {
    this.switchChanged.emit(event);
  }
}
